const StaffValidationIcon = ({
  height = "24px",
  width = "24px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7162 12.8L10.0302 11.114C9.73824 10.822 9.26224 10.822 8.97024 11.114C8.67724 11.407 8.67724 11.882 8.97024 12.175L10.8432 14.049C11.0872 14.293 11.4212 14.425 11.7662 14.414C12.1112 14.403 12.4362 14.25 12.6652 13.992C13.5982 12.934 16.0622 10.141 16.0622 10.141C16.3362 9.83001 16.3072 9.35601 15.9962 9.08201C15.6862 8.80801 15.2112 8.83801 14.9382 9.14801L11.7162 12.8Z"
        fill="#404040"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2951 6.55325C21.2951 5.87325 20.9021 5.25525 20.2871 4.96525C18.6771 4.20725 14.1601 2.08225 12.7471 1.41725C12.2741 1.19425 11.7261 1.19425 11.2531 1.41725L3.71308 4.96525C3.09808 5.25525 2.70508 5.87325 2.70508 6.55325V9.80625L2.72708 10.2222C3.76308 19.5833 11.7251 22.6982 11.7251 22.6982C11.9021 22.7673 12.0981 22.7673 12.2751 22.6982C12.2751 22.6982 20.2371 19.5833 21.2691 10.2222C21.2851 10.0843 21.2921 9.94525 21.2921 9.80625C21.2951 9.31325 21.2951 7.52525 21.2951 6.55325ZM19.7951 6.55325C19.7951 7.52225 19.7951 9.30725 19.7921 9.80225L19.7781 10.0573C18.9591 17.4832 13.3191 20.5583 12.0001 21.1803C10.6811 20.5583 5.04008 17.4832 4.21808 10.0582L4.20508 9.80625C4.20508 9.31025 4.20508 7.52425 4.20508 6.55325C4.20508 6.45425 4.26208 6.36425 4.35208 6.32225L11.8911 2.77425C11.9601 2.74225 12.0401 2.74225 12.1091 2.77425L19.6481 6.32225C19.7381 6.36425 19.7951 6.45425 19.7951 6.55325Z"
        fill="#404040"
      />
    </svg>
  );
};
export default StaffValidationIcon;
